import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { config } from "./config";

if (window.location.hostname !== "localhost") {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_SITE,
    service: import.meta.env.VITE_DATADOG_SERVICE,
    env: import.meta.env.VITE_DATADOG_ENV,
    version: config.version ?? "unknown",

    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: false })],
    allowedTracingUrls: [import.meta.env.VITE_DATADOG_ALLOWED_TRACING_URL],
  });
}

datadogLogs.init({
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: import.meta.env.VITE_DATADOG_SITE,
  service: import.meta.env.VITE_DATADOG_SERVICE,
  env: import.meta.env.VITE_DATADOG_ENV,
  version: config.version ?? "unknown",
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

if (window.location.hostname === "localhost") {
  datadogLogs.logger.setHandler("console");
}
